export default function buildShouldExcludeKey(exceptValues) {
  const exceptKeyNames = [];
  const exceptKeyNameRegExps = [];

  for (const k of exceptValues) {
    const match = k.match(/^\/(?<regexp>.+)\/$/);

    if (match === null) {
      exceptKeyNames.push(k);
    } else {
      exceptKeyNameRegExps.push(new RegExp(`^${match.groups.regexp}$`));
    }
  }

  return (key) => {
    if (exceptKeyNames.includes(key)) {
      return true;
    }

    for (const pattern of exceptKeyNameRegExps) {
      if (pattern.test(key)) {
        return true;
      }
    }

    return false;
  };
}
